$(document).ready(function () {
  $('.tvsport').on('click', function () {
    $('.tvsport').removeClass('active');
    $(this).addClass('active');

    var sport = $(this).data('sport');

    if (sport === 'all') {
      $('.event-row').show();
    } else {
      $('.event-row').hide();

      $('.event-row[data-sport="' + sport + '"]').show();
    }
  });

  document.querySelectorAll('.event-row:not(.onlive) .event-toggle').forEach(function(button) {
    button.addEventListener('click', handleToggle, true);
    button.addEventListener('touchstart', handleToggle, true);
  });

  $('.event-row:not(.onlive)').on('click', function(e) {
    var $row = $(this);

    if (!$row.find('.event-full-description').length) {
      return;
    }

    if ($(e.target).closest('.event-toggle').length) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    handleToggle.call($row[0], e);
  });

  function handleToggle(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var $eventRow = $(this).closest('.event-row');
    var $description = $eventRow.find('.event-full-description');
    var $button = $eventRow.find('.event-toggle');

    if ($description.length) {
      var isExpanded = $button.hasClass('expanded');

      $description.slideToggle(200);
      $button.toggleClass('expanded');
      $button.attr('aria-expanded', !isExpanded);
      $button.attr('aria-label', isExpanded ? 'Покажи повече информация' : 'Скрий информация');
    }

    return false;
  }
});